import { Input, Checkbox, CheckboxGroup, ScrollShadow } from '@nextui-org/react'
import { useState } from 'react'
const platforms = [
  { value: 'sam.gov', label: 'SAM' },
  { value: 'bunde.de', label: 'Bund.de' },
  { value: 'deutsch-evergave', label: 'Deutsche eVergabe' },
  { value: 'dtvp.de', label: 'Deutsches Vergabeportal' },
  { value: 'esa', label: 'The European Space Agency' },
  { value: 'evergabe-online.de', label: 'eVergabe' },
  { value: 'rib.de', label: 'RIB' },
  { value: 'ted.eu', label: 'TED - EU Tenders' },
  { value: 'ausschreibungen.usp.gv.at', label: 'Unternehmensservice Portal' },
  { value: 'simap.ch', label: 'simap.ch' },
]
export default function SourcePicker({ selectedValue, onSelect }) {
  const [searchValue, setSearchValue] = useState<string>('')
  return (
    <div className="flex flex-col gap-2">
      <Input
        placeholder="e.g TED"
        onChange={(e) => setSearchValue(e.target.value)}
        variant="bordered"
        label="Platform name"
        value={searchValue}
      />
      <ScrollShadow className="max-h-[350px] pt-2 pb-2">
        <CheckboxGroup onChange={(selectedKeys) => onSelect(selectedKeys)} value={selectedValue}>
          {platforms
            .filter((item) => item.label.toLowerCase().startsWith(searchValue.toLowerCase()))
            .map((p: any) => (
              <Checkbox key={p.value} value={p.value} classNames={{ label: 'text-sm' }}>
                {p.label}
              </Checkbox>
            ))}
        </CheckboxGroup>
      </ScrollShadow>
    </div>
  )
}
